<template>
	<div>
		<div class="topic-report-main-conatiner">
			<div class="headtext d-flex align-items-center justify-content-between">
				<div class="heading headtext">
					<span>Individual Topic Report for '{{ topicDetails.name }}'</span>
				</div>
			</div>
			<b-row>
				<b-col lg="9" sm="12">
					<div class="topicreport-first-subcontainer">
						<div>
							<div class="topicreport-first-head">{{ topicDetails.name }}</div>
							<hr />
							<div class="d-flex align-items-center justify-content-around">
								<div class="d-flex flex-column">
									<span class="pd-card-middle-head">Name</span>
									<span class="reporttopic-subheadings">{{
										topicDetails.name
									}}</span>
								</div>
								<div class="d-flex flex-column">
									<span class="pd-card-middle-head">Description</span>
									<span class="reporttopic-subheadings">{{
										topicDetails.description
									}}</span>
								</div>
								<div class="d-flex flex-column">
									<span class="pd-card-middle-head">Total Candidates</span>
									<span class="bluenumbertext">{{
										topicDetails.totalCandidates
									}}</span>
								</div>
								<div class="d-flex flex-column ml-3">
									<span class="pd-card-middle-head">Total Tests</span>

									<span class="yellownumbertext">{{
										topicDetails.totalTests
									}}</span>
								</div>
							</div>
						</div>
					</div>
				</b-col>
				<b-col lg="3" sm="12">
					<div>
						<img src="../../../assets/icons/Reports/report1.svg" alt="" />
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="8" sm="12">
					<div
						class="
              topicreport-first-subcontainer topicreport-second-subcontainer
            "
					>
						<div class="tabcard-testconfig tabcard-testconfig2 py-2 px-5">
							<UsageLine />
						</div>
					</div>
				</b-col>
				<b-col lg="4" sm="12">
					<div
						class="
              topicreport-first-subcontainer topicreport-second-subcontainer
            "
					>
						<div class="topicreports-second-card">
							<span class="topicreport-subhead">Star Candidates</span>
							<div
								class="position-middle"
								v-if="candidatesTableData.length === 0"
							>
								No tests taken
							</div>
							<div
								class="pd-cards"
								v-for="(candidate, index) in candidatesTableData.slice(0, 5)"
								:key="index"
							>
								<div class="d-flex relativeclass tp-gridcont flexgrid">
									<div
										:style="{
											background:
												'#' +
												Math.random()
													.toString(16)
													.substr(-6),
										}"
										class="gridgreencolorDynamic"
									></div>

									<div class="d-flex flex-column ml-3" style="width: 70%">
										<span class="pd-card-middle-head">Name</span>
										<span class="reporttopic-subheadings">{{
											candidate.name
										}}</span>
									</div>

									<div class="d-flex flex-column" style="width: 30%">
										<span class="pd-card-middle-head">Total Test Taken</span>
										<span class="bluenumbertext">{{ candidate.value }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>

			<b-row class="mt-3 h-100">
				<b-col lg="8" sm="12">
					<div
						class="
              topicreport-first-subcontainer topicreport-second-subcontainer
            "
					>
						<div class="reporttopic-third-subhead">Most Active Tests</div>
						<TrendBarGraphs subject="test" :topicId="this.topicId" />
					</div>
				</b-col>
				<b-col lg="4" sm="12">
					<div
						class="
              topicreport-first-subcontainer topicreport-second-subcontainer
            "
					>
						<span class="topicreport-subhead">Test Details</span>
						<div class="topicreports-second-card">
							<div
								class="pd-cards pointer"
								v-for="test in testsTableData"
								@click="
									handleTestCardClick(test.testID, test.totalSections, test)
								"
								:title="
									test.totalSections > 0
										? 'Click to view test details'
										: 'No sections added to this test'
								"
								:key="test.testID"
							>
								<div class="d-flex relativeclass tp-gridcont flexgrid">
									<div
										:style="{
											background:
												'#' +
												Math.random()
													.toString(16)
													.substr(-6),
										}"
										class="gridgreencolorDynamic"
									></div>

									<div class="d-flex flex-column ml-3" style="width: 30%">
										<span class="pd-card-middle-head">Name</span>
										<span class="reporttopic-subheadings">{{
											test.name.length > 20
												? test.name.substr(0, 20).concat("...")
												: test.name
										}}</span>
									</div>

									<div class="d-flex flex-column" style="width: 22%">
										<span class="pd-card-middle-head">Total sections</span>

										<span class="yellownumbertext">{{
											test.totalSections
										}}</span>
									</div>
									<div class="d-flex flex-column" style="width: 22%">
										<span class="pd-card-middle-head">Maximum Marks</span>
										<span class="bluenumbertext">{{ test.totalMarks }}</span>
									</div>
									<div class="d-flex flex-column" style="width: 22%">
										<span class="pd-card-middle-head">Test taken</span>
										<span class="bluenumbertext">{{
											test.totalCandidates
										}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import TrendBarGraphs from "../shared/TrendBarGraphs.vue";
import UsageLine from "../shared/UsageLine.vue";
import {
	getTestInformation,
	getTopicActiveStudents,
	getTopicInformation,
} from "../../../utils/apiFunctions";
export default {
	name: "TopicReport",
	components: {
		UsageLine,
		TrendBarGraphs,
	},
	data() {
		return {
			index: 25,
			isLoading: true,
			topicId: this.$route.params.topicID,
			topicDetails: {},
			testsTableData: [],
			testsTableFields: [
				{ key: "slNo", sortable: true, label: "Sl No." },
				{ key: "name", sortable: true, label: "Name" },
				{ key: "totalSections", sortable: true, label: "Total Sections" },
				{ key: "totalCandidates", sortable: true, label: "Total Tests Taken" },
			],
			candidatesTableData: [],
			candidatesTableFields: [
				{ key: "slNo", sortable: true, label: "Sl No." },
				{ key: "name", sortable: true, label: "Name" },
				{ key: "value", sortable: true, label: "Total tests taken" },
			],
		};
	},
	async mounted() {
		try {
			const response = await this.getData();
			this.isLoading = false;
			this.topicDetails = response.topicDetails;
			this.testsTableData = response.testsTableData;
			this.candidatesTableData = response.candidatesTableData;
		} catch (e) {
			console.error("Error getting data", e);
		}
	},
	methods: {
		async getData() {
			const values = await Promise.all([
				getTopicInformation(this.topicId),
				getTopicActiveStudents(this.topicId),
				getTestInformation(this.topicId),
			]);
			values.forEach((data) => {
				if (data.data.type !== "Success") {
					throw new Error("Request Failed because " + data.data.Detail);
				}
			});
			return {
				topicDetails: values[0].data.data,
				candidatesTableData: values[1].data.data,
				testsTableData: values[2].data.data,
			};
		},

		handleTestCardClick(testID, totalSections, test) {
			let data = {
				testName: test.name,
				topicID: this.topicId,
			};
			this.$store.commit("searchVUEX/saveReportDetails", data);
			if (totalSections > 0) {
				this.$router.push({
					path: `/reports/test/${this.topicId}/${testID}/`,
				});
			}
		},
	},
};
</script>

<style scoped>
.position-middle {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.gridgreencolorDynamic {
	width: 4px;
	height: 60px;
	border-radius: 2px;
	position: absolute;
	left: -5px;
	top: -8px;
}
.topic-report-main-conatiner {
	height: calc(100vh - 85px);
	position: relative;
	top: 70px;
	overflow: auto;
	margin-left: 60px;
	padding: 15px 25px;
	width: calc(100vw - 60px);
}
.topicreport-first-subcontainer {
	background: #ffffff;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	padding: 20px 10px;
	margin: 10px 0;
}
.topicreport-first-head {
	font-weight: 500;
	padding-left: 40px;
	font-size: 14px;
	line-height: 21px;
	color: #72738e;
}
.topicreport-second-subcontainer {
	height: 100%;
}
.topicreports-second-card {
	height: 55vh;
	overflow: auto;
}

.topicreport-subhead {
	font-size: var(--size-14);
	font-weight: var(--weight-M);
	color: var(--bg-tertiary);
	margin-left: 20px;
}
</style>
